import {
  PaymentOption,
  PaymentType,
} from '@/modules/checkout/_core/domain/entities'

export const TABS = [
  PaymentOption.CreditCard,
  PaymentOption.BankSlip,
  PaymentOption.Pix,
]

export const getTabKey = (paymentType: PaymentType) =>
  paymentType.type === PaymentOption.Redirect
    ? `${PaymentOption.Redirect}-${paymentType.id}`
    : paymentType.type

export const getVisibleTabKeys = (types: PaymentType[]) => {
  const has = (type: PaymentOption) =>
    types.some((method) => method.type === type)

  const keys: string[] = []

  if (has(PaymentOption.CreditCard) || has(PaymentOption.DebitCard)) {
    keys.push(PaymentOption.CreditCard)
  }

  if (has(PaymentOption.BankSlip)) {
    keys.push(PaymentOption.BankSlip)
  }

  if (has(PaymentOption.Pix) || has(PaymentOption.AutomaticPixCopyPaste)) {
    keys.push(PaymentOption.Pix)
  }

  types
    .filter((method) => method.type === PaymentOption.Redirect)
    .forEach((redirect) => keys.push(getTabKey(redirect)))

  return keys
}
